module.exports = __webpack_public_path__ + "static/media/better-together.94753d85.png";